import React, { useCallback, useEffect, useRef, useState } from "react";
import {
  Button,
  Container,
  Content,
  Header,
  Loader,
  SelectPicker,
  Checkbox,
  Radio,
  CheckPicker,
} from "rsuite";
import { Form, Field } from "react-final-form";
import { updateIn } from "json-immut/updateIn";
import { render } from "react-dom";
import { UserServices } from "../../../core/services/UserServices";
import { CustomerServices } from "../../../core/services/CustomerServices";
import { HelperServices } from "../../../core/services/HelperServices";
import { StoreServices } from "../../../core/services/StoreServices";
import "./Customer.css";
import { Link, useNavigate, useParams } from "react-router-dom";
import { get, debounce, padStart } from "lodash/fp";
import { UtilityServices } from "../../../core/services/UtilityServices";
import { useSelector } from "react-redux";
import CustomSelector from "../../shared/customSelector";
import { useTranslation } from "react-i18next";
import useDecryptedParams from "../../../navigation/useDecryptParams";
import {
  messageTypeArr,
  roleTypeArr,
  onOffArr,
  statusArr,
  customerTypeObjArr,
  retentionTypeObjArr,
  ratingObjArr,
  genderArr,
  monthArr,
  monthDaysArr,
  religionObjArr,
  religionObj,
} from "../../../core/config/AppConstants";
import { ValidatorCustom } from "../../validators/ValidatorCustom";
import { ContentRoutes } from "../../../navigation/NavConstant";
import {
  addLabelValue,
  getStdCodesFromCountryList,
  getPincodeForArea,
  getPrimaryAddress,
  isEmptyVal,
  isNotEmpty,
  isNotNull,
  zeroFill,
  getStdCodeForCountry,
} from "../../../utils/helpers";
import moment, { RFC_2822 } from "moment";
function Customer({
  forCompany,
  forStore,
  onAdd,
  withHeader = true,
  withCancelButton = true,
  withCredentials = true,
  openInModal = false,
  defaultValues = { customer_source_id: "" },
}: {
  forCompany?: number;
  forStore?: number;
  onAdd?: Function;
  withHeader?: boolean;
  withCancelButton?: boolean;
  withCredentials?: boolean;
  openInModal?: boolean;
  defaultValues?: any;
}) {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [loader, setLoading] = useState(false);
  const [storeList, setStoreList] = useState([]);
  const countryList = useSelector((state: any) => state.country.data);
  const stdCodeList = getStdCodesFromCountryList(countryList);
  const params: any = useParams();
  const selectedCompany = useSelector((state: any) => state.company);
  const searchData = useSelector((state: any) => state.user);
  const [file, setFile] = useState<any>();
  const [updateCustomerImage, setUpdateCustomerImage] = useState("");
  const [customerCategoryList, setCustomerCategoryList] = useState([] as any);
  const [customerSourceList, setCustomerSourceList] = useState([] as any);
  const [stateList, setStateList] = useState([]);
  const [cityList, setCityList] = useState([]);
  const [areaList, setAreaList] = useState([]);
  const [buildingList, setBuildingList] = useState([]);
  const [editCustomerCompany, setEditCustomerCompany] = useState<number>();
  const defaultSettings = UtilityServices.getLoggedInUser("settings");
  let mob,
    nm = "";
  let searchString = searchData.searchString;
  if (!isNaN(Number(searchString))) {
    mob = searchString;
  } else {
    nm = searchString;
  }

  const [formData, setFormData] = useState<any>({
    email: "",
    name: "",
    fname: nm,
    lname: "",
    country_code: !isEmptyVal(defaultSettings["default_country"])
      ? getStdCodeForCountry(defaultSettings["default_country"], countryList)
      : "91",
    mobile: mob,
    birthday: "",
    birthday_month: "",
    birthday_day: "",
    anniversary: "",
    anniversary_month: "",
    anniversary_day: "",
    username: "",
    password: "",
    confirm_password: "",
    store_id: UtilityServices.getLoggedInUser("store_id"),
    comp_id: "",
    city_id: !isEmptyVal(defaultSettings["default_city"])
      ? parseInt(defaultSettings["default_city"])
      : "",
    profession: "",
    designation: "",
    country_id: !isEmptyVal(defaultSettings["default_country"])
      ? parseInt(defaultSettings["default_country"])
      : "",
    state_id: !isEmptyVal(defaultSettings["default_state"])
      ? parseInt(defaultSettings["default_state"])
      : "",
    address_mobile: "",
    house_no: "",
    building: "",
    building_id: "",
    area_name: "",
    area_id: !isEmptyVal(defaultSettings["default_area"])
      ? parseInt(defaultSettings["default_area"])
      : "",
    landmark: "",
    pincode: "",
    customer_rating: "",
    customer_type: "standard",
    retention_type: "retained",
    category_ids: "",
    customer_source_id: defaultValues?.customer_source_id,
    customer_detail: "",
    status: statusArr.active,
    gender: !isEmptyVal(defaultSettings["default_customer_gender"])
      ? defaultSettings["default_customer_gender"]
      : "",
    religion: religionObj.hindu,
    receive_notification: onOffArr.on,
    new_area: onOffArr.off,
    new_building: onOffArr.off,
  });
  const [errorMessage, setErrorMessage] = useState("");
  const [cityNotFound, setCityNotFound] = useState(false);
  const [stateNotFound, setSateNotFound] = useState(false);
  const [areaNotFound, setAreaNotFound] = useState(false);
  const [buildingNotFound, setBuildingNotFound] = useState(false);
  const [createNewArea, setCreateNewArea] = useState(false);
  const [createNewBuilding, setCreateNewBuilding] = useState(false);
  const [isUsernameAllowed, setIsUsernameAllowed] = useState(true);
  let [decryptedParams] = useDecryptedParams(params);
  const [showMoreInfo, setShowMoreInfo] = useState(false);
  const handleMoreInfoToggle = () => setShowMoreInfo(!showMoreInfo);

  async function init() {
    try {
      if (decryptedParams.id) {
        setLoading(true);
        const response: any = await CustomerServices.viewCustomer(
          +decryptedParams.id
        );
        const respData = get("data.data", response);
        const primaryAddress = getPrimaryAddress(respData.user);
        const userInfo = isNotEmpty(respData.user) ? respData.user : [];
        let obj = { ...formData };
        if (respData.user.image_url) {
          setUpdateCustomerImage(respData.user.image_url);
        }
        Object.keys(obj).map((formKeys) => {
          if (respData[formKeys]) {
            obj[formKeys] = respData[formKeys];
          }
          if (!respData[formKeys] && primaryAddress[formKeys]) {
            obj[formKeys] = primaryAddress[formKeys];
          }
          if (!respData[formKeys] && userInfo[formKeys]) {
            obj[formKeys] = userInfo[formKeys];
          }
          if (formKeys === "comp_id") {
            obj[formKeys] = obj["company_id"] = respData.company_id;
          }
          if (formKeys === "status") {
            obj[formKeys] = respData.status.toString();
          }
          if (formKeys === "building") {
            obj[formKeys] = primaryAddress["building_name"];
          }
          if (formKeys === "address_mobile") {
            obj[formKeys] = primaryAddress["mobile"];
          }
        });
        obj.status = obj.status.toString();
        obj.customer_rating = obj.customer_rating.toString();
        obj.birthday_month = zeroFill(obj.birthday_month.toString(), 2);
        obj.birthday_day = zeroFill(obj.birthday_day.toString(), 2);
        obj.anniversary_month = zeroFill(obj.anniversary_month.toString(), 2);
        obj.anniversary_day = zeroFill(obj.anniversary_day.toString(), 2);

        if (+obj?.store_id > 0) {
          handleFormChanges({ path: "store_id", value: obj?.store_id });
        }
        if (+obj?.company_id > 0) {
          storeSearch("", obj.company_id);
          getCustomerCategory(obj.company_id);
          getCustomerSource(obj.company_id);
          setEditCustomerCompany(obj.company_id);
        }
        preSelectFields(obj);
        setFormData({ ...obj });
        setLoading(false);
      } else {
        initValues();
      }
    } catch (error: any) {
      UtilityServices.showToaster({
        message: error.message,
        type: messageTypeArr.error,
      });

      navigate(ContentRoutes.CUSTOMERS);
    }
  }

  async function preSelectFields(obj: any, overrideFormWithPin = false) {
    if (obj.country_id) {
      handleCountryChange(obj.country_id);
    }
    if (obj.state_id) {
      handleStateChange(obj.state_id);
    }
    if (obj?.city_id && obj?.state_id && obj?.country_id) {
      handleCityChange(obj.city_id, null, overrideFormWithPin);
    }
    if (obj?.area_id && obj?.city_id && obj?.state_id && obj?.country_id) {
      handleAreaChange(obj.area_id);
    }
    if (
      obj?.building_id &&
      obj?.area_id &&
      obj?.city_id &&
      obj?.state_id &&
      obj?.country_id
    ) {
      handleBuildingChange(obj.building_id);
    }
  }

  function initValues() {
    if (!params?.id) {
      loadUserDefaultSettings();
    }
  }

  function handleFormChanges(data: any, form?: any) {
    if (form) {
      let frm = updateIn(form.getState().values, [data.path], data.value);
      setFormData(frm);
    }
  }

  function loadUserDefaultSettings() {
    setLoading(true);

    let obj = { ...formData };
    preSelectFields(obj, true);
    setLoading(false);
  }

  useEffect(() => {
    init();
  }, [decryptedParams.id]);

  useEffect(() => {
    if (!params.id) {
      getCustomerCategory();
      getCustomerSource();
      storeSearch("");
    }
  }, [selectedCompany]);

  function getCompanyId() {
    let compId = 0;
    if (UtilityServices.getLoggedInUser("user_type") === roleTypeArr.client) {
      compId = UtilityServices.getLoggedInUser("company_id");
    } else if (decryptedParams.id && editCustomerCompany) {
      compId = editCustomerCompany;
    } else if (selectedCompany?.id && !decryptedParams.id) {
      compId = selectedCompany.id;
    }
    return compId;
  }

  async function getCustomerCategory(forComp?: number) {
    let compId: number = forComp ? forComp : getCompanyId();
    let custCatArr: any[] = [];
    if (!compId) {
      setCustomerCategoryList(custCatArr);
      return;
    }
    try {
      const res = await CustomerServices.getCustomerCategories({
        company: compId,
      });
      const respData = get("data.data", res);
      if (respData.length) {
        custCatArr = addLabelValue(respData, "category_name", "id");
      }
      setCustomerCategoryList(custCatArr);
    } catch (error: any) {
      UtilityServices.showToaster({
        message: error.message,
        type: messageTypeArr.error,
      });
    }
  }

  async function getCustomerSource(forComp?: number) {
    let compId: number = forComp ? forComp : getCompanyId();
    if (!compId) {
      return;
    }
    try {
      const res = await CustomerServices.getCustomerSources({
        company: compId,
      });
      const respData = get("data.data", res);
      setCustomerSourceList(respData);
    } catch (error: any) {
      UtilityServices.showToaster({
        message: error.message,
        type: messageTypeArr.error,
      });
    }
  }

  async function storeSearch(searchStore: string, forComp?: number) {
    let compId: number = forComp ? forComp : getCompanyId();

    if (!compId) {
      return;
    }
    try {
      const res = await StoreServices.getStores({
        company: compId,
        smart_search: searchStore,
      });
      const respData = get("data.data", res);
      setStoreList(respData);
    } catch (error: any) {
      UtilityServices.showToaster({
        message: error.message,
        type: messageTypeArr.error,
      });
    }
  }

  async function handleCountryChange(countryId: any, form?: any) {
    if (form) {
      form.change("country_id", countryId);
      form.change("state_id", "");
      form.change("city_id", "");
      form.change("building", "");
      form.change("area_name", "");
      form.change("area_id", "");
      form.change("building_id", "");
      setCityList([]);
      setAreaList([]);
      setBuildingList([]);
    }

    try {
      const stateRes = await HelperServices.getAllValidStates({
        country: countryId,
      });
      const respData = get("data.data", stateRes);
      setStateList(respData);
      setSateNotFound(!respData.length);
    } catch (error) {
      console.log(error);
    }
  }

  async function handleStateChange(stateId: any, form?: any) {
    if (form) {
      form.change("state_id", stateId);
      form.change("city_id", "");
      form.change("building", "");
      form.change("area_name", "");
      form.change("area_id", "");
      form.change("building_id", "");
      setAreaList([]);
      setBuildingList([]);
    }

    try {
      const res = await HelperServices.getAllValidCities({ state: stateId });
      const respData = get("data.data", res);
      setCityList(respData);
      setCityNotFound(!respData.length);
    } catch (error) {
      console.log(error);
    }
  }

  async function handleCityChange(
    cityId: any,
    form?: any,
    overrideFormWithPin = false
  ) {
    if (form) {
      form.change("city_id", cityId);
      form.change("building", "");
      form.change("area_name", "");
      form.change("area_id", "");
      form.change("building_id", "");
      setBuildingList([]);
    }
    try {
      const res = await HelperServices.getAllValidAreas({ city: cityId });
      const respData = get("data.data", res);
      setAreaList(respData);
      if (overrideFormWithPin) {
        setFormData({
          ...formData,
          ...{ pincode: getPincodeForArea(formData.area_id, respData) },
        });
      }

      setAreaNotFound(!respData.length);
    } catch (error) {
      console.log(error);
    }
  }

  async function handleAreaChange(areaId: any, form?: any) {
    if (form) {
      form.change("area_id", areaId);
      form.change("building", "");
      form.change("area_name", "");
      form.change("building_id", "");
      form.change("pincode", getPincodeForArea(areaId, areaList));
    }

    try {
      const res = await HelperServices.getAllValidBuildings({ area: areaId });
      const respData = get("data.data", res);
      setBuildingList(respData);
      setBuildingNotFound(!respData.length);
    } catch (error) {
      console.log(error);
    }
  }

  async function handleBuildingChange(buildingId: any, form?: any) {
    if (form) {
      form.change("building_id", buildingId);
    }
  }

  function checkCompanySelected() {
    if (!getCompanyId() && !decryptedParams.id) {
      UtilityServices.showToaster({
        message: t("REQUIRED_SELECT", {
          field: t("COMPANY").toLowerCase(),
        }),
        type: messageTypeArr.error,
      });
    }
  }

  function resetSelectionFor(resetFor: string, form?: any) {
    switch (resetFor) {
      case "country":
        form.change("country_id", "");
        form.change("state_id", "");
        form.change("city_id", "");
        form.change("building", "");
        form.change("building_id", "");
        form.change("area_name", "");
        form.change("area_id", "");
        setStateList([]);
        setCityList([]);
        setAreaList([]);
        setBuildingList([]);
        break;
      case "state":
        form.change("state_id", "");
        form.change("city_id", "");
        form.change("building", "");
        form.change("building_id", "");
        form.change("area_name", "");
        form.change("area_id", "");
        setCityList([]);
        setAreaList([]);
        setBuildingList([]);
        break;
      case "city":
        form.change("city_id", "");
        form.change("building", "");
        form.change("building_id", "");
        form.change("area_name", "");
        form.change("area_id", "");
        setAreaList([]);
        setBuildingList([]);
        break;
      case "area":
        form.change("building", "");
        form.change("building_id", "");
        form.change("area_name", "");
        form.change("area_id", "");
        setBuildingList([]);
        break;
      case "building":
        form.change("building", "");
        form.change("building_id", "");
        break;
    }
  }

  async function saveCustomer(form: any, id?: number) {
    try {
      setLoading(true);
      let response: any;
      if (id) {
        response = await CustomerServices.updateCustomer(+id, form);
      } else {
        response = await CustomerServices.createCustomer(form);
      }
      setLoading(false);
      UtilityServices.showToaster({
        message: response?.data?.message,
      });
      if (onAdd !== undefined) {
        onAdd(response?.data?.data);
      } else {
        navigate(ContentRoutes.CUSTOMERS);
      }
    } catch (error: any) {
      setLoading(false);
      UtilityServices.showToaster({
        message: error?.message,
        type: messageTypeArr.error,
      });
      setErrorMessage(error?.message);
    }
  }

  const dbounceUsername = useCallback(
    debounce(500, (value: string) => {
      checkUserName(value);
    }),
    []
  );

  const handleUsernameCheck = (value: string) => {
    dbounceUsername(value);
  };

  async function checkUserName(name: string) {
    if (decryptedParams.id) return;
    try {
      const res = await UserServices.checkUserNameAvailablity({
        username: name,
      });
      setIsUsernameAllowed(false);
    } catch (error: any) {
      setIsUsernameAllowed(true);
    }
  }

  const onSubmit = (val: any) => {
    const form = new FormData();
    for (var key in formData) {
      if (isNotNull(val[key])) form.append(key, val[key]);
    }
    if (file) {
      form.append("image", file, file.name);
    }
    if (
      isEmptyVal(form.get("fname")) &&
      isEmptyVal(form.get("email")) &&
      isEmptyVal(form.get("mobile"))
    ) {
      UtilityServices.showToaster({
        type: "warning",
        message: t("REQUIRED", {
          field:
            t("FIRST_NAME").toLowerCase() +
            " " +
            t("OR").toLowerCase() +
            " " +
            t("MOBILE").toLowerCase() +
            " " +
            t("OR").toLowerCase() +
            " " +
            t("EMAIL").toLowerCase(),
        }),
      });
      return;
    }

    if (!decryptedParams.id) {
      let compId: number = getCompanyId();
      form.set("comp_id", compId.toString());
      if (!compId) {
        UtilityServices.showToaster({
          message: t("REQUIRED_SELECT", {
            field: t("COMPANY").toLowerCase(),
          }),
          type: messageTypeArr.error,
        });
        return;
      }
    }

    if (!isEmptyVal(form.get("birthday_month"))) {
      let bday: string = "";
      bday = moment().format("YYYY") + "-";
      bday = bday + form.get("birthday_month") + "-";
      if (form.get("birthday_day") != "") {
        bday = bday + form.get("birthday_day");
      } else {
        bday = bday + moment().format("DD");
      }
      form.set("birthday", bday);
    }

    if (!isEmptyVal(form.get("anniversary_month"))) {
      let anday: string = "";
      anday = moment().format("YYYY") + "-";
      anday = anday + form.get("anniversary_month") + "-";
      if (form.get("anniversary_day") != "") {
        anday = anday + form.get("anniversary_day");
      } else {
        anday = anday + moment().format("DD");
      }
      form.set("anniversary", anday);
    }

    if (form.get("new_area") !== "0" && form.get("area_name") != "") {
      form.delete("area_id");
    }

    if (form.get("new_building") !== "0" && form.get("building") != "") {
      form.delete("building_id");
    }

    if (decryptedParams.id) {
      form.delete("comp_id");
      form.delete("password");
      form.delete("confirm_password");
      saveCustomer(form, decryptedParams.id);
    } else {
      saveCustomer(form);
    }
  };
  return (
    <div className="customer">
      {loader && (
        <Loader
          style={{ zIndex: 9999 }}
          size="lg"
          content={t("LOADING")}
          center
          backdrop={true}
        />
      )}
      <Container className="container">
        {withHeader && (
          <Header className="header">
            <h4>
              {decryptedParams.id ? t("UPDATE") : t("CREATE")} {t("CUSTOMER")}
            </h4>
          </Header>
        )}

        <Content className="content customer-create-wrap mt-2">
          <Form
            onSubmit={onSubmit}
            validate={(values: any) => {
              const errors: any = {};
              if (values.username && values.username.length < 4) {
                errors.username = t("AT_LEAST", {
                  field: t("USERNAME"),
                  char: 4,
                });
              }
              if (values.mobile && values.mobile.length !== 10) {
                errors.mobile = t("VALID", {
                  entity: t("MOBILE").toLowerCase(),
                });
              }
              if (!values.gender) {
                errors.gender = t("REQUIRED_SELECT", {
                  field: t("GENDER").toLowerCase(),
                });
              }
              if (!params?.id) {
                if (values.password && !values.confirm_password) {
                  errors.confirm_password = t("REQUIRED", {
                    field: t("CONFIRM_PASSWORD").toLowerCase(),
                  });
                }
              }
              if (
                values.address_mobile &&
                values.address_mobile?.length !== 10
              ) {
                errors.address_mobile = t("VALID", {
                  entity: t("MOBILE").toLowerCase(),
                });
              }
              return errors;
            }}
            initialValues={{ ...formData }}
            render={({ handleSubmit, form }) => (
              <form onSubmit={handleSubmit}>
                <Field name="image">
                  {({ input, meta }) => (
                    <div className="flex-item">
                      <div className="d-flex usr-img">
                        <div>
                          <img
                            className="usr-img-bx"
                            src={
                              file
                                ? URL.createObjectURL(file)
                                : updateCustomerImage
                                ? updateCustomerImage
                                : UtilityServices.getLoggedInUser(
                                    "user_default_image"
                                  )
                            }
                            alt={t("CUSTOMER") + " " + t("IMAGE")}
                            title={t("CUSTOMER") + " " + t("IMAGE")}
                          />
                        </div>
                        <input
                          id="image-upload"
                          {...input}
                          type="file"
                          accept="image/png, image/gif, image/jpeg"
                          onChangeCapture={(e: any) => {
                            setFile(e.target.files[0]);
                          }}
                          style={{ display: "none" }}
                        />
                        <label
                          className="customer-image-upload-lbl"
                          htmlFor="image-upload"
                        >
                          {t("UPLOAD")} {t("IMAGE")}
                        </label>
                      </div>
                    </div>
                  )}
                </Field>
                <div className="form-part">
                  <div className="flex-container">
                    <Field name="country_code">
                      {({ input, meta }) => (
                        <div className="flex-item">
                          <label>{t("CODE")}</label>
                          <SelectPicker
                            data={stdCodeList}
                            valueKey="country_std_code"
                            labelKey="country_std_code"
                            onSelect={(value, item) => {
                              handleFormChanges(
                                { path: "country_code", value },
                                form
                              );
                            }}
                            onClean={(e: any) => {
                              handleFormChanges(
                                {
                                  path: "country_code",
                                  value: "",
                                },
                                form
                              );
                            }}
                            name="country_code"
                            value={formData?.country_code}
                          />
                          {meta.error && meta.touched && (
                            <span>{meta.error}</span>
                          )}
                        </div>
                      )}
                    </Field>
                    <Field
                      name="mobile"
                      validate={ValidatorCustom.mobilePatternValidation}
                    >
                      {({ input, meta }) => (
                        <div className="flex-item">
                          <label>{t("MOBILE")}*</label>
                          <input {...input} type="text" autoComplete="off" />
                          {meta.error && meta.touched && (
                            <span>{meta.error}</span>
                          )}
                        </div>
                      )}
                    </Field>
                    <Field name="fname">
                      {({ input, meta }) => (
                        <div className="flex-item">
                          <label>{t("FIRST_NAME")}*</label>
                          <input {...input} type="text" />
                          {meta.error && meta.touched && (
                            <span>{meta.error}</span>
                          )}
                        </div>
                      )}
                    </Field>
                    <Field name="lname">
                      {({ input, meta }) => (
                        <div className="flex-item">
                          <label>{t("LAST_NAME")}</label>
                          <input {...input} type="text" autoComplete="off" />
                          {meta.error && meta.touched && (
                            <span>{meta.error}</span>
                          )}
                        </div>
                      )}
                    </Field>
                    <Field name="store_id">
                      {({ input, meta }) => (
                        <div className="flex-item">
                          <label>{t("STORE")}</label>
                          <SelectPicker
                            data={storeList}
                            onSearch={(e: any) => {
                              if (e) {
                                storeSearch(e);
                              }
                            }}
                            valueKey="id"
                            labelKey="store_name"
                            onSelect={(value, item) => {
                              handleFormChanges(
                                { path: "store_id", value },
                                form
                              );
                            }}
                            onClean={(e: any) => {
                              handleFormChanges(
                                {
                                  path: "store_id",
                                  value: "",
                                },
                                form
                              );
                            }}
                            name="store_id"
                            value={formData?.store_id}
                          />
                          {meta.error && meta.touched && (
                            <span>{meta.error}</span>
                          )}
                        </div>
                      )}
                    </Field>
                    <Field name="country_id">
                      {({ input, meta }) => (
                        <div className="flex-item">
                          <CustomSelector
                            loaderMsg={t("FETCHING_DATA_OF", {
                              field: t("COUNTRY").toLocaleLowerCase(),
                            })}
                            isRequired={false}
                            valueKey="id"
                            labelKey="country_name"
                            isDisable={!countryList?.length ? true : false}
                            labelName={t("COUNTRY")}
                            defaultValue={input.value}
                            onClear={(event: any) => {
                              resetSelectionFor("country", form);
                            }}
                            listData={countryList?.length ? countryList : []}
                            onSelect={(e: any, selectedObj: any) => {
                              handleCountryChange(e, form);
                            }}
                          />
                          {meta.error && meta.touched && (
                            <span>{meta.error}</span>
                          )}
                        </div>
                      )}
                    </Field>
                  </div>
                  <div className="flex-container">
                    <Field name="state_id">
                      {({ input, meta }) => (
                        <div className="flex-item">
                          <CustomSelector
                            loaderMsg={
                              form.getState().values.country_id &&
                              !stateList?.length
                                ? t("FETCHING_DATA_OF", {
                                    field: t("STATE").toLocaleLowerCase(),
                                  })
                                : ""
                            }
                            valueKey="id"
                            labelKey="state_name"
                            isRequired={false}
                            isDisable={!stateList?.length ? true : false}
                            labelName={t("STATE")}
                            defaultValue={input.value}
                            onClear={(event: any) => {
                              resetSelectionFor("state", form);
                            }}
                            listData={
                              form.getState().values.country_id &&
                              stateList?.length
                                ? stateList
                                : [{}]
                            }
                            onSelect={(e: any, selectedObj: any) => {
                              handleStateChange(e, form);
                            }}
                          />
                          {meta.error && meta.touched && (
                            <span>{meta.error}</span>
                          )}
                          {meta.error &&
                            meta.touched &&
                            form.getState().values.country_id &&
                            !stateList?.length && <br />}
                          {form.getState().values.country_id &&
                            !stateList?.length &&
                            !stateNotFound && (
                              <span>
                                {t("FETCHING_DATA_OF", { field: t("STATE") })}
                              </span>
                            )}
                          {form.getState().values.country_id &&
                            !stateList?.length &&
                            stateNotFound && (
                              <span>
                                {t("NO_DATA_FOUND_OF", {
                                  field: t("STATE").toLocaleLowerCase(),
                                })}
                              </span>
                            )}
                        </div>
                      )}
                    </Field>
                    <Field name="city_id">
                      {({ input, meta }) => (
                        <div className="flex-item">
                          <CustomSelector
                            loaderMsg={
                              form.getState().values.state_id &&
                              !cityList?.length
                                ? t("FETCHING_DATA_OF", { field: t("CITY") })
                                : ""
                            }
                            valueKey="id"
                            labelKey="city_name"
                            isRequired={false}
                            isDisable={!cityList?.length ? true : false}
                            labelName={t("CITY")}
                            defaultValue={input.value}
                            onClear={(event: any) => {
                              resetSelectionFor("city", form);
                            }}
                            listData={
                              form.getState().values.state_id &&
                              cityList?.length
                                ? cityList
                                : [{}]
                            }
                            onSelect={(e: any, selectedObj: any) => {
                              handleCityChange(e, form);
                            }}
                          />
                          {meta.error && meta.touched && (
                            <span>{meta.error}</span>
                          )}
                          {meta.error &&
                            meta.touched &&
                            form.getState().values.state_id &&
                            !cityList?.length && <br />}
                          {form.getState().values.state_id &&
                            !cityList?.length &&
                            !cityNotFound && (
                              <span>
                                {t("FETCHING_DATA_OF", {
                                  field: t("CITY").toLocaleLowerCase(),
                                })}
                              </span>
                            )}
                          {form.getState().values.state_id && cityNotFound && (
                            <span>
                              {t("NO_DATA_FOUND_OF", {
                                field: t("CITY").toLocaleLowerCase(),
                              })}
                            </span>
                          )}
                        </div>
                      )}
                    </Field>
                    <>
                      <Field name="new_area">
                        {({ input, meta }) => (
                          <div className="flex-item">
                            <Checkbox
                              name="new_area"
                              checked={
                                input.value === onOffArr.on ? true : false
                              }
                              onChangeCapture={(e: any) => {
                                if (e.target.checked) {
                                  form.change("new_area", onOffArr.on);
                                  form.change("new_building", onOffArr.on);
                                  setCreateNewArea(true);
                                  setCreateNewBuilding(true);
                                } else {
                                  form.change("new_area", onOffArr.off);
                                  form.change("new_building", onOffArr.off);
                                  setCreateNewArea(false);
                                  setCreateNewBuilding(false);
                                }
                              }}
                              value={onOffArr.on}
                            ></Checkbox>
                            <label className="inline">
                              {t("NEW")} {t("AREA")}
                            </label>
                          </div>
                        )}
                      </Field>
                      {createNewArea ? (
                        <Field
                          name="area_name"
                          validate={
                            ValidatorCustom.isAlphaNumericDashSpacePatternValidator
                          }
                        >
                          {({ input, meta }) => (
                            <div className="flex-item">
                              <label>{t("AREA")}</label>
                              <input
                                {...input}
                                type="text"
                                disabled={
                                  form.getState().values.city_id ? false : true
                                }
                                autoComplete="off"
                                onChange={(event: any) => {
                                  form.change("area_name", event.target.value);
                                }}
                              />
                              {meta.error && meta.touched && (
                                <span>{meta.error}</span>
                              )}
                            </div>
                          )}
                        </Field>
                      ) : (
                        <Field name="area_id">
                          {({ input, meta }) => (
                            <div className="flex-item">
                              <CustomSelector
                                loaderMsg={
                                  form.getState().values.area_id &&
                                  !areaList?.length
                                    ? t("FETCHING_DATA_OF", {
                                        field: t("AREA"),
                                      })
                                    : ""
                                }
                                valueKey="id"
                                labelKey="area_name"
                                isRequired={false}
                                isDisable={!areaList?.length ? true : false}
                                labelName={t("AREA")}
                                defaultValue={input.value}
                                onClear={(event: any) => {
                                  resetSelectionFor("area", form);
                                }}
                                listData={
                                  form.getState().values.city_id &&
                                  areaList?.length
                                    ? areaList
                                    : [{}]
                                }
                                onSelect={(e: any, selectedObj: any) => {
                                  handleAreaChange(e, form);
                                }}
                              />
                              {meta.error && meta.touched && (
                                <span>{meta.error}</span>
                              )}
                              {meta.error &&
                                meta.touched &&
                                form.getState().values.city_id &&
                                !areaList?.length && <br />}
                              {form.getState().values.city_id &&
                                !areaList?.length &&
                                !areaNotFound && (
                                  <span>
                                    {t("FETCHING_DATA_OF", {
                                      field: t("AREA").toLocaleLowerCase(),
                                    })}
                                  </span>
                                )}
                              {form.getState().values.city_id &&
                                areaNotFound && (
                                  <span>
                                    {t("NO_DATA_FOUND_OF", {
                                      field: t("AREA").toLocaleLowerCase(),
                                    })}
                                  </span>
                                )}
                            </div>
                          )}
                        </Field>
                      )}
                    </>
                    <>
                      <Field name="new_building">
                        {({ input, meta }) => (
                          <div className="flex-item">
                            <Checkbox
                              name="new_building"
                              checked={
                                input.value === onOffArr.on ? true : false
                              }
                              onChangeCapture={(e: any) => {
                                if (e.target.checked) {
                                  form.change("new_building", onOffArr.on);
                                  setCreateNewBuilding(true);
                                } else {
                                  form.change("new_building", onOffArr.off);
                                  setCreateNewBuilding(false);
                                }
                              }}
                              value={onOffArr.on}
                            ></Checkbox>
                            <label className="inline">
                              {t("NEW")} {t("BUILDING")}
                            </label>
                          </div>
                        )}
                      </Field>
                      {createNewBuilding ? (
                        <Field
                          name="building"
                          validate={
                            ValidatorCustom.isAlphaNumericDashSpacePatternValidator
                          }
                        >
                          {({ input, meta }) => (
                            <div className="flex-item">
                              <label>{t("BUILDING")}</label>
                              <input
                                {...input}
                                type="text"
                                disabled={
                                  form.getState().values.city_id ? false : true
                                }
                                autoComplete="off"
                                onChange={(event: any) => {
                                  form.change("building", event.target.value);
                                }}
                              />
                              {meta.error && meta.touched && (
                                <span>{meta.error}</span>
                              )}
                            </div>
                          )}
                        </Field>
                      ) : (
                        <Field name="building_id">
                          {({ input, meta }) => (
                            <div className="flex-item">
                              <CustomSelector
                                loaderMsg={
                                  form.getState().values.building_id &&
                                  !buildingList?.length
                                    ? t("FETCHING_DATA_OF", {
                                        field: t("BUILDING"),
                                      })
                                    : ""
                                }
                                valueKey="id"
                                labelKey="building_name"
                                isRequired={false}
                                isDisable={!buildingList?.length ? true : false}
                                labelName={t("BUILDING")}
                                defaultValue={input.value}
                                onClear={(event: any) => {
                                  resetSelectionFor("building", form);
                                }}
                                listData={
                                  form.getState().values.area_id &&
                                  buildingList?.length
                                    ? buildingList
                                    : [{}]
                                }
                                onSelect={(e: any, selectedObj: any) => {
                                  handleBuildingChange(e, form);
                                }}
                              />
                              {meta.error && meta.touched && (
                                <span>{meta.error}</span>
                              )}
                              {meta.error &&
                                meta.touched &&
                                form.getState().values.area_id &&
                                !buildingList?.length && <br />}
                              {form.getState().values.area_id &&
                                !buildingList?.length &&
                                !buildingNotFound && (
                                  <span>
                                    {t("FETCHING_DATA_OF", {
                                      field: t("BUILDING").toLocaleLowerCase(),
                                    })}
                                  </span>
                                )}
                              {form.getState().values.area_id &&
                                buildingNotFound && (
                                  <span>
                                    {t("NO_DATA_FOUND_OF", {
                                      field: t("BUILDING").toLocaleLowerCase(),
                                    })}
                                  </span>
                                )}
                            </div>
                          )}
                        </Field>
                      )}
                    </>
                  </div>
                  <div className="flex-container">
                    <Field name="house_no">
                      {({ input, meta }) => (
                        <div className="flex-item">
                          <label>{t("HOUSE_NO")}</label>
                          <input {...input} type="text" autoComplete="off" />
                          {meta.error && meta.touched && (
                            <span>{meta.error}</span>
                          )}
                        </div>
                      )}
                    </Field>
                    <Field
                      name="landmark"
                      validate={
                        ValidatorCustom.isAlphaNumericDashSpacePatternValidator
                      }
                    >
                      {({ input, meta }) => (
                        <div className="flex-item">
                          <label>{t("LANDMARK")}</label>
                          <input {...input} type="text" autoComplete="off" />
                          {meta.error && meta.touched && (
                            <span>{meta.error}</span>
                          )}
                        </div>
                      )}
                    </Field>
                    <Field
                      name="pincode"
                      validate={
                        ValidatorCustom.isAlphaNumericDashSpacePatternValidator
                      }
                    >
                      {({ input, meta }) => (
                        <div className="flex-item">
                          <label>{t("PINCODE")}</label>
                          <input {...input} type="text" autoComplete="off" />
                          {meta.error && meta.touched && (
                            <span>{meta.error}</span>
                          )}
                        </div>
                      )}
                    </Field>
                    <Field
                      name="address_mobile"
                      validate={ValidatorCustom.mobilePatternValidation}
                    >
                      {({ input, meta }) => (
                        <div className="flex-item">
                          <label>
                            {t("ALTERNATE")} {t("MOBILE")}
                          </label>
                          <input {...input} type="text" autoComplete="off" />
                          {meta.error && meta.touched && (
                            <span>{meta.error}</span>
                          )}
                        </div>
                      )}
                    </Field>
                  </div>
                  <div className="flex-container">
                    <Field
                      name="email"
                      validate={ValidatorCustom.emailPatternValidator}
                    >
                      {({ input, meta }) => (
                        <div className="flex-item">
                          <label>{t("EMAIL")}</label>
                          <input {...input} type="text" autoComplete="off" />
                          {meta.error && meta.touched && (
                            <span>{meta.error}</span>
                          )}
                        </div>
                      )}
                    </Field>
                    <Field name="gender">
                      {({ input, meta }) => (
                        <div className="flex-item gndr-item">
                          <label>{t("GENDER")}</label>
                          <Radio
                            onChangeCapture={(e: any) => {
                              if (e.target.checked) {
                                form.change("gender", genderArr.male);
                              }
                            }}
                            checked={
                              input.value === genderArr.male ? true : false
                            }
                            name="gender"
                            value={genderArr.male}
                          >
                            {t("MALE")}
                          </Radio>
                          <Radio
                            onChangeCapture={(e: any) => {
                              if (e.target.checked) {
                                form.change("gender", genderArr.female);
                              }
                            }}
                            checked={
                              input.value === genderArr.female ? true : false
                            }
                            name="gender"
                            value={genderArr.female}
                          >
                            {t("FEMALE")}
                          </Radio>
                          <Radio
                            onChangeCapture={(e: any) => {
                              if (e.target.checked) {
                                form.change("gender", genderArr.trans_gender);
                              }
                            }}
                            checked={
                              input.value === genderArr.trans_gender
                                ? true
                                : false
                            }
                            name="gender"
                            value={genderArr.trans_gender}
                          >
                            {t("TRANS_GENDER")}
                          </Radio>
                          {meta.error && meta.touched && (
                            <span>{meta.error}</span>
                          )}
                        </div>
                      )}
                    </Field>
                    <Field name="status">
                      {({ input, meta }) => (
                        <div className="flex-item">
                          {/* <label className="inline"> */}
                          <label>{t("STATUS")}</label>
                          <Radio
                            onChangeCapture={(e: any) => {
                              if (e.target.checked) {
                                form.change("status", statusArr.active);
                              }
                            }}
                            checked={
                              input.value === statusArr.active ? true : false
                            }
                            name="status"
                            value={statusArr.active}
                          >
                            {t("ACTIVE")}
                          </Radio>
                          <Radio
                            onChangeCapture={(e: any) => {
                              if (e.target.checked) {
                                form.change("status", statusArr.inactive);
                              }
                            }}
                            checked={
                              input.value === statusArr.inactive ? true : false
                            }
                            name="status"
                            value={statusArr.inactive}
                          >
                            {t("INACTIVE")}
                          </Radio>
                          {meta.error && meta.touched && (
                            <span>{meta.error}</span>
                          )}
                        </div>
                      )}
                    </Field>
                    <Field name="receive_notification">
                      {({ input, meta }) => (
                        <div className="flex-item">
                          <label>{t("RECEIVE_NOTIFICATION")}</label>
                          <Checkbox
                            name="receive_notification"
                            checked={input.value === onOffArr.on ? true : false}
                            onChangeCapture={(e: any) => {
                              if (e.target.checked) {
                                form.change(
                                  "receive_notification",
                                  onOffArr.on
                                );
                              }
                            }}
                            value={onOffArr.on}
                          >
                            {t("YES")}
                          </Checkbox>
                          <Checkbox
                            checked={
                              input.value === onOffArr.off ? true : false
                            }
                            name="receive_notification"
                            onChangeCapture={(e: any) => {
                              if (e.target.checked) {
                                form.change(
                                  "receive_notification",
                                  onOffArr.off
                                );
                              }
                            }}
                            value={onOffArr.off}
                          >
                            {t("NO")}
                          </Checkbox>
                        </div>
                      )}
                    </Field>
                  </div>
                </div>
                {withCredentials && (
                  <>
                    <div
                      className="address-bx d-flex"
                      onClick={handleMoreInfoToggle}
                    >
                      <h5>
                        {t("CREDENTIALS")} {t("AND").toLowerCase()}{" "}
                        {t("OTHERS").toLowerCase()}
                      </h5>
                      {showMoreInfo ? (
                        <svg
                          fill="currentColor"
                          xmlns="http://www.w3.org/2000/svg"
                          viewBox="0 0 512 512"
                        >
                          <path d="M233.4 105.4c12.5-12.5 32.8-12.5 45.3 0l192 192c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L256 173.3 86.6 342.6c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3l192-192z" />
                        </svg>
                      ) : (
                        <svg
                          fill="currentColor"
                          xmlns="http://www.w3.org/2000/svg"
                          viewBox="0 0 512 512"
                        >
                          <path d="M233.4 406.6c12.5 12.5 32.8 12.5 45.3 0l192-192c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L256 338.7 86.6 169.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l192 192z" />
                        </svg>
                      )}
                    </div>
                    <div className="form-part">
                      {showMoreInfo && (
                        <>
                          <div className="flex-container">
                            <Field
                              name="username"
                              validate={
                                ValidatorCustom.whiteSpacePatterValidator
                              }
                            >
                              {({ input, meta }) => (
                                <div className="flex-item">
                                  <label>{t("USERNAME")}</label>
                                  <input
                                    {...input}
                                    type="text"
                                    autoComplete="off"
                                    onChangeCapture={(e: any) => {
                                      let val = e.target.value;
                                      if (val && val.length > 3) {
                                        handleUsernameCheck(val);
                                      }
                                    }}
                                  />
                                  {meta.error && meta.touched && (
                                    <span>{meta.error}</span>
                                  )}
                                  {!meta.error &&
                                    meta.touched &&
                                    !isUsernameAllowed && (
                                      <span>
                                        {t("USERNAME_VALIDATION", {
                                          value: t(input.value),
                                        })}
                                      </span>
                                    )}
                                </div>
                              )}
                            </Field>
                            {!params?.id && (
                              <>
                                <Field
                                  name="password"
                                  validate={
                                    ValidatorCustom.passwordPatternValidator
                                  }
                                >
                                  {({ input, meta }) => (
                                    <div className="flex-item">
                                      <label>{t("PASSWORD")}</label>
                                      <input
                                        {...input}
                                        type="password"
                                        autoComplete="off"
                                      />
                                      {meta.error && meta.touched && (
                                        <span>{meta.error}</span>
                                      )}
                                    </div>
                                  )}
                                </Field>
                                <Field name="confirm_password">
                                  {({ input, meta }) => (
                                    <div className="flex-item">
                                      <label>
                                        {t("CONFIRM")} {t("PASSWORD")}
                                      </label>
                                      <input
                                        {...input}
                                        type="password"
                                        autoComplete="off"
                                      />
                                      {meta.error && meta.touched && (
                                        <span>{meta.error}</span>
                                      )}
                                      {!meta.error &&
                                        meta.touched &&
                                        form.getState().values.password &&
                                        form.getState().values.password !==
                                          form.getState().values
                                            .confirm_password && (
                                          <>
                                            <br />
                                            <span>
                                              {t("DOES_NOT_MATCH", {
                                                field1: t("CONFIRM_PASSWORD"),
                                                field2:
                                                  t("PASSWORD").toLowerCase(),
                                              })}
                                            </span>
                                          </>
                                        )}
                                    </div>
                                  )}
                                </Field>
                              </>
                            )}
                            <Field name="customer_source_id">
                              {({ input, meta }) => (
                                <div className="flex-item">
                                  <label>
                                    {t("CUSTOMER")} {t("SOURCE")}
                                  </label>
                                  <SelectPicker
                                    data={customerSourceList}
                                    valueKey="id"
                                    labelKey="source_name"
                                    onSelect={(value, item) => {
                                      handleFormChanges(
                                        {
                                          path: "customer_source_id",
                                          value,
                                        },
                                        form
                                      );
                                    }}
                                    onClean={(e: any) => {
                                      handleFormChanges(
                                        {
                                          path: "customer_source_id",
                                          value: "",
                                        },
                                        form
                                      );
                                    }}
                                    name="customer_source_id"
                                    value={formData?.customer_source_id}
                                  />
                                  {meta.error && meta.touched && (
                                    <span>{meta.error}</span>
                                  )}
                                </div>
                              )}
                            </Field>
                          </div>
                          <div className="flex-container">
                            <Field name="birthday_month">
                              {({ input, meta }) => (
                                <div className="flex-item">
                                  <label>
                                    {t("BIRTHDAY")} {t("MONTH")}
                                  </label>
                                  <SelectPicker
                                    data={monthArr}
                                    valueKey="value"
                                    labelKey="label"
                                    onSelect={(value, item) => {
                                      handleFormChanges(
                                        {
                                          path: "birthday_month",
                                          value,
                                        },
                                        form
                                      );
                                    }}
                                    onClean={(e: any) => {
                                      handleFormChanges(
                                        {
                                          path: "birthday_month",
                                          value: "",
                                        },
                                        form
                                      );
                                    }}
                                    name="birthday_month"
                                    value={formData?.birthday_month}
                                  />
                                  {meta.error && meta.touched && (
                                    <span>{meta.error}</span>
                                  )}
                                </div>
                              )}
                            </Field>
                            <Field name="birthday_day">
                              {({ input, meta }) => (
                                <div className="flex-item">
                                  <label>{t("DAY")}</label>
                                  <SelectPicker
                                    data={monthDaysArr}
                                    valueKey="value"
                                    labelKey="label"
                                    onSelect={(value, item) => {
                                      handleFormChanges(
                                        {
                                          path: "birthday_day",
                                          value,
                                        },
                                        form
                                      );
                                    }}
                                    onClean={(e: any) => {
                                      handleFormChanges(
                                        {
                                          path: "birthday_day",
                                          value: "",
                                        },
                                        form
                                      );
                                    }}
                                    name="birthday_day"
                                    value={formData?.birthday_day}
                                  />
                                  {meta.error && meta.touched && (
                                    <span>{meta.error}</span>
                                  )}
                                </div>
                              )}
                            </Field>
                            <Field name="anniversary_month">
                              {({ input, meta }) => (
                                <div className="flex-item">
                                  <label>
                                    {t("ANNIVERSARY")} {t("MONTH")}
                                  </label>
                                  <SelectPicker
                                    data={monthArr}
                                    valueKey="value"
                                    labelKey="label"
                                    onSelect={(value, item) => {
                                      handleFormChanges(
                                        {
                                          path: "anniversary_month",
                                          value,
                                        },
                                        form
                                      );
                                    }}
                                    onClean={(e: any) => {
                                      handleFormChanges(
                                        {
                                          path: "anniversary_month",
                                          value: "",
                                        },
                                        form
                                      );
                                    }}
                                    name="anniversary_month"
                                    value={formData?.anniversary_month}
                                  />
                                  {meta.error && meta.touched && (
                                    <span>{meta.error}</span>
                                  )}
                                </div>
                              )}
                            </Field>
                            <Field name="anniversary_day">
                              {({ input, meta }) => (
                                <div className="flex-item">
                                  <label>{t("DAY")}</label>
                                  <SelectPicker
                                    data={monthDaysArr}
                                    valueKey="value"
                                    labelKey="label"
                                    onSelect={(value, item) => {
                                      handleFormChanges(
                                        {
                                          path: "anniversary_day",
                                          value,
                                        },
                                        form
                                      );
                                    }}
                                    onClean={(e: any) => {
                                      handleFormChanges(
                                        {
                                          path: "anniversary_day",
                                          value: "",
                                        },
                                        form
                                      );
                                    }}
                                    name="anniversary_day"
                                    value={formData?.anniversary_day}
                                  />
                                  {meta.error && meta.touched && (
                                    <span>{meta.error}</span>
                                  )}
                                </div>
                              )}
                            </Field>
                          </div>
                          <div className="flex-container">
                            <Field name="customer_type">
                              {({ input, meta }) => (
                                <div className="flex-item">
                                  <label>
                                    {t("CUSTOMER")} {t("TYPE")}
                                  </label>
                                  <SelectPicker
                                    data={customerTypeObjArr}
                                    valueKey="value"
                                    labelKey="label"
                                    onSelect={(value, item) => {
                                      handleFormChanges(
                                        {
                                          path: "customer_type",
                                          value,
                                        },
                                        form
                                      );
                                    }}
                                    onClean={(e: any) => {
                                      handleFormChanges(
                                        {
                                          path: "customer_type",
                                          value: "",
                                        },
                                        form
                                      );
                                    }}
                                    name="customer_type"
                                    value={formData?.customer_type}
                                  />
                                  {meta.error && meta.touched && (
                                    <span>{meta.error}</span>
                                  )}
                                </div>
                              )}
                            </Field>
                            <Field name="retention_type">
                              {({ input, meta }) => (
                                <div className="flex-item">
                                  <label>
                                    {t("RETENTION")} {t("TYPE")}
                                  </label>
                                  <SelectPicker
                                    data={retentionTypeObjArr}
                                    valueKey="value"
                                    labelKey="label"
                                    onSelect={(value, item) => {
                                      handleFormChanges(
                                        {
                                          path: "retention_type",
                                          value,
                                        },
                                        form
                                      );
                                    }}
                                    onClean={(e: any) => {
                                      handleFormChanges(
                                        {
                                          path: "retention_type",
                                          value: "",
                                        },
                                        form
                                      );
                                    }}
                                    name="retention_type"
                                    value={formData?.retention_type}
                                  />
                                  {meta.error && meta.touched && (
                                    <span>{meta.error}</span>
                                  )}
                                </div>
                              )}
                            </Field>
                            <Field name="category_ids">
                              {({ input, meta }) => (
                                <div className="flex-item">
                                  <label>
                                    {t("CUSTOMER")} {t("CATEGORY")}
                                  </label>
                                  <CheckPicker
                                    sticky
                                    onChange={(e: any) => {
                                      let custCat: any = e.filter(isNotEmpty);
                                      if (e.length) {
                                        handleFormChanges(
                                          {
                                            path: "category_ids",
                                            value: custCat.toString(),
                                          },
                                          form
                                        );
                                      } else {
                                        handleFormChanges(
                                          {
                                            path: "category_ids",
                                            value: "",
                                          },
                                          form
                                        );
                                      }
                                    }}
                                    onClean={() => {
                                      handleFormChanges(
                                        {
                                          path: "category_ids",
                                          value: "",
                                        },
                                        form
                                      );
                                    }}
                                    data={customerCategoryList}
                                    value={formData?.category_ids?.split(",")}
                                  />
                                  {meta.error && meta.touched && (
                                    <span>{meta.error}</span>
                                  )}
                                </div>
                              )}
                            </Field>
                            <Field name="customer_rating">
                              {({ input, meta }) => (
                                <div className="flex-item">
                                  <label>
                                    {t("CUSTOMER")} {t("RATING")}
                                  </label>
                                  <SelectPicker
                                    data={ratingObjArr}
                                    valueKey="value"
                                    labelKey="label"
                                    onSelect={(value, item) => {
                                      handleFormChanges(
                                        {
                                          path: "customer_rating",
                                          value,
                                        },
                                        form
                                      );
                                    }}
                                    onClean={(e: any) => {
                                      handleFormChanges(
                                        {
                                          path: "customer_rating",
                                          value: "",
                                        },
                                        form
                                      );
                                    }}
                                    name="customer_rating"
                                    value={formData?.customer_rating}
                                  />
                                  {meta.error && meta.touched && (
                                    <span>{meta.error}</span>
                                  )}
                                </div>
                              )}
                            </Field>
                          </div>
                          <div className="flex-container">
                            <Field name="profession">
                              {({ input, meta }) => (
                                <div className="flex-item">
                                  <label>{t("PROFESSION")}</label>
                                  <input
                                    {...input}
                                    type="text"
                                    autoComplete="off"
                                  />
                                  {meta.error && meta.touched && (
                                    <span>{meta.error}</span>
                                  )}
                                </div>
                              )}
                            </Field>
                            <Field name="designation">
                              {({ input, meta }) => (
                                <div className="flex-item">
                                  <label>{t("DESIGNATION")}</label>
                                  <input
                                    {...input}
                                    type="text"
                                    autoComplete="off"
                                  />
                                  {meta.error && meta.touched && (
                                    <span>{meta.error}</span>
                                  )}
                                </div>
                              )}
                            </Field>
                            <Field name="religion">
                              {({ input, meta }) => (
                                <div className="flex-item">
                                  <label>{t("RELIGION")}</label>
                                  <SelectPicker
                                    data={religionObjArr}
                                    valueKey="value"
                                    labelKey="label"
                                    onSelect={(value, item) => {
                                      handleFormChanges(
                                        {
                                          path: "religion",
                                          value,
                                        },
                                        form
                                      );
                                    }}
                                    onClean={(e: any) => {
                                      handleFormChanges(
                                        {
                                          path: "religion",
                                          value: "",
                                        },
                                        form
                                      );
                                    }}
                                    name="religion"
                                    value={formData?.religion}
                                  />
                                  {meta.error && meta.touched && (
                                    <span>{meta.error}</span>
                                  )}
                                </div>
                              )}
                            </Field>
                            <Field name="customer_detail">
                              {({ input, meta }) => (
                                <div className="flex-item">
                                  <label>
                                    {t("CUSTOMER")} {t("DETAIL")}/{t("REMARKS")}
                                  </label>
                                  <textarea
                                    {...input}
                                    autoComplete="off"
                                    rows={5}
                                    cols={30}
                                  />
                                  {meta.error && meta.touched && (
                                    <span>{meta.error}</span>
                                  )}
                                </div>
                              )}
                            </Field>
                          </div>
                        </>
                      )}
                    </div>
                  </>
                )}

                <div className="create-action d-flex flex-end">
                  {withCancelButton && (
                    <Link to={ContentRoutes.CUSTOMERS}>
                      <Button appearance="primary" color="red" type="button">
                        {t("CANCEL")}
                      </Button>
                    </Link>
                  )}
                  <Button appearance="primary" color="green" type="submit">
                    {decryptedParams.id ? t("UPDATE") : t("CREATE")}
                  </Button>
                  <Button
                    appearance="default"
                    type="reset"
                    onClick={() => {
                      // review comment: move to new function
                      form.reset();
                      setFile("");
                      setUpdateCustomerImage("");
                      setIsUsernameAllowed(true);
                      if (form.getState().values.country_id) {
                        handleCountryChange(form.getState().values.country_id);
                      }
                      if (form.getState().values.state_id) {
                        handleStateChange(form.getState().values.state_id);
                      }
                    }}
                  >
                    {t("RESET")}
                  </Button>
                </div>
              </form>
            )}
          />
        </Content>
      </Container>
    </div>
  );
}

export default Customer;
